import ViewLoading from "shared/UI/Spinners/ViewLoading";

export const PageLoader = ({ title }: { title: string }) => {
  return (
    <div className="flex items-center justify-center h-full md:h-auto">
      <div className="space-y-4">
        <p className="font-bold">{title}...</p>
        <ViewLoading label={title} />
      </div>
    </div>
  );
};
